import { apiGet } from './apiConfig';
import type {
  Client,
  Currency,
  Unit,
  RiskCategory,
  RiskImpact,
  OperatingModel,
  ClientUnit,
  ClientUnitsQueryParams,
  LastRefreshDate
} from '../../types/api';

/**
 * Lookup API Service
 * Handles all lookup table endpoints
 */
export class LookupService {
  /**
   * Get all clients (admin only)
   */
  async getClients(): Promise<Client[]> {
    return await apiGet('/clients/');
  }

  /**
   * Get all currencies
   */
  async getCurrencies(): Promise<Currency[]> {
    return await apiGet('/currencies/');
  }

  /**
   * Get all risk categories
   */
  async getRiskCategories(): Promise<RiskCategory[]> {
    return await apiGet('/risk_categories/');
  }

  /**
   * Get all risk impacts
   */
  async getRiskImpacts(): Promise<RiskImpact[]> {
    return await apiGet('/risk_impacts/');
  }

  /**
   * Get all operating models
   */
  async getOperatingModels(): Promise<OperatingModel[]> {
    return await apiGet('/operating_models/');
  }

  /**
   * Get all units
   */
  async getUnits(): Promise<Unit[]> {
    return await apiGet('/units/');
  }

  /**
   * Get last refresh date
   */
  async getLastRefreshDate(): Promise<LastRefreshDate[]> {
    return await apiGet('/last_refresh_date/');
  }

  /**
   * Get client units for a specific user
   */
  async getClientUnits(params: ClientUnitsQueryParams): Promise<ClientUnit[]> {
    return await apiGet('/client_units/', params);
  }
}

// Create and export a single instance
export const lookupService = new LookupService();

